import "./style.scss";
import { useEffect, useState } from "react";
import { useSpring, animated } from "@react-spring/web";
import useMeasure from "react-use-measure";

export default function Dropdown({
  summary,
  details,
  open,
  setOpen,
  className = "",
  disabled = false,
  absolute = false,
}) {
  const [contentHeight, setContentHeight] = useState("0px");
  const [contentRef, { height }] = useMeasure();

  const expand = useSpring({
    height: open ? `${contentHeight}px` : "0px",
  });

  const opacity = useSpring({
    opacity: open ? `1` : "0",
  });

  useEffect(() => {
    setContentHeight(height);
    window.addEventListener("resize", setContentHeight(height));

    return () => {
      window.removeEventListener("resize", setContentHeight(height));
    };
  }, [height]);

  return (
    <div
      className={`dropdown ${className} ${disabled ? "disabled" : ""}`}
      data-open={open}
    >
      <button
        type="button"
        onClick={() => {
          if (!disabled) setOpen();
        }}
      >
        <div className="upper">{summary}</div>
      </button>
      <animated.div
        style={{
          ...expand,
          overflow: open ? "" : "hidden",
          position: absolute ? "absolute" : "static",
        }}
        aria-hidden={!open}
        inert={!open ? "" : undefined}
      >
        <animated.div
          style={{
            ...opacity,
          }}
          className="content"
          ref={contentRef}
        >
          {details}
        </animated.div>
      </animated.div>
    </div>
  );
}
